// hooks/useSmoothScrollTo.js
import { useNavigate, useLocation } from 'react-router-dom';

// ─── useSmoothScrollTo ────────────────────────────────────────────────────────
// Returns a scrollTo function that can be called with a section id.
// If already on the homepage, scrolls directly.
// If on another page, navigates to '/#sectionId' and lets Homepage handle the scroll.
export function useSmoothScrollTo() {
  const navigate = useNavigate();
  const location = useLocation();

  return (sectionId) => {
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/#${sectionId}`);
    }
  };
}